import { cn } from '../lib/utils';

type Props = {
  className?: string;
  size?: 'sm' | 'md';
  /** `mark` shows only the symbol for narrow spaces. */
  variant?: 'wordmark' | 'mark';
};

export default function PulseLogo({ className, size = 'sm', variant = 'wordmark' }: Props) {
  const symbol = (
    <img
      src="/bb-symbol.png"
      alt={variant === 'mark' ? 'Pulse' : ''}
      className={cn('shrink-0 select-none', size === 'sm' ? 'h-7 w-7' : 'h-12 w-12')}
    />
  );
  if (variant === 'mark') return <span className={cn('block', className)}>{symbol}</span>;
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      {symbol}
      <span
        className={cn(
          'font-display font-extrabold tracking-tight text-foreground',
          size === 'sm' ? 'text-lg' : 'text-3xl',
        )}
      >
        Pulse
      </span>
    </span>
  );
}
